// extracted by mini-css-extract-plugin
module.exports =  {"body":"body--FEa_a","body-grid":"body-grid--vNCgv","bodyGrid":"body-grid--vNCgv"};